"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Svg = _interopRequireDefault(require("../Svg/Svg"));
var _Alert = _interopRequireDefault(require("../Alert/Alert"));
var Input = function Input(_ref) {
  var label = _ref.label,
    type = _ref.type,
    required = _ref.required,
    icon = _ref.icon,
    placeholder = _ref.placeholder,
    disabled = _ref.disabled,
    invalid = _ref.invalid,
    labelHidden = _ref.labelHidden,
    name = _ref.name,
    value = _ref.value,
    onChange = _ref.onChange,
    id = _ref.id,
    dataRepeatType = _ref.dataRepeatType,
    alert = _ref.alert,
    className = _ref.className,
    noMargin = _ref.noMargin,
    min = _ref.min,
    max = _ref.max;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(className, " d8-c-input ").concat(!noMargin && 'margin-bottom-sm')
  }, !labelHidden && /*#__PURE__*/_react["default"].createElement("label", {
    className: "form-label margin-bottom-sm",
    htmlFor: id || label.replace(/\s+/g, '-').toLowerCase(),
    "data-section": "form-label"
  }, label), /*#__PURE__*/_react["default"].createElement("div", {
    className: "d8-u-relative"
  }, icon && /*#__PURE__*/_react["default"].createElement("span", {
    className: "pre--icon"
  }, /*#__PURE__*/_react["default"].createElement(_Svg["default"], {
    name: icon
  })), invalid && /*#__PURE__*/_react["default"].createElement("span", {
    className: "end--icon error--icon"
  }, /*#__PURE__*/_react["default"].createElement(_Svg["default"], {
    name: "cross"
  })), type === 'search' && /*#__PURE__*/_react["default"].createElement("span", {
    className: "end--icon search--icon"
  }, /*#__PURE__*/_react["default"].createElement(_Svg["default"], {
    name: "cross"
  })), /*#__PURE__*/_react["default"].createElement("input", {
    className: "form-control ".concat(icon && 'padding-left-lg', " ").concat(invalid || type === 'search' && 'padding-right-lg'),
    type: type,
    name: name,
    id: id || label.replace(/\s+/g, '-').toLowerCase(),
    required: required,
    "data-section": "form-control",
    placeholder: placeholder,
    "aria-invalid": invalid,
    disabled: disabled,
    value: type === 'number' ? value !== undefined && value !== null ? value : '' : value || '',
    onChange: onChange,
    "aria-label": label,
    title: label,
    "data-repeat-type": dataRepeatType,
    min: min,
    max: max
  })), alert && /*#__PURE__*/_react["default"].createElement(_Alert["default"], {
    className: "margin-top-sm",
    show: alert.showNotification,
    text: alert.notificationMessage,
    type: alert.notificationType,
    onClose: alert.onClose
  }));
};
Input.propTypes = {
  label: _propTypes["default"].string,
  icon: _propTypes["default"].string,
  placeholder: _propTypes["default"].string,
  name: _propTypes["default"].string,
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  onChange: _propTypes["default"].func,
  type: _propTypes["default"].string,
  required: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  invalid: _propTypes["default"].bool,
  labelHidden: _propTypes["default"].bool,
  id: _propTypes["default"].string,
  dataRepeatType: _propTypes["default"].string,
  alert: _propTypes["default"].object,
  className: _propTypes["default"].string,
  noMargin: _propTypes["default"].bool,
  min: _propTypes["default"].number,
  max: _propTypes["default"].number
};
Input.defaultProps = {
  required: false,
  alert: null
};
var _default = exports["default"] = Input;